export default __webpack_public_path__ + "static/media/leaf6.bc4e3f78.svg";